import React from 'react';

export default function Footer() {
    return (
        <footer className="bg-[#631F07] text-white text-sm font-bold w-full">
            <div className="flex flex-col items-center gap-4 px-4 py-6">

                <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-6">
                    <a href="mailto:membership@iooflivermore219.org" className="text-white hover:text-[#D5BD5D]">
                        membership@iooflivermore219.org
                    </a>
                    <span className="hidden sm:inline">|</span>
                    <a href="tel:+19252921766" className="text-white hover:text-[#D5BD5D]">
                        (925) 292-1766
                    </a>
                </div>

                <div className="flex flex-col sm:flex-row items-center gap-1 sm:gap-2 text-center">
                    <p>Copyright 2026 Livermore Odd Fellows Lodge #219</p>
                    <span className="hidden sm:inline">|</span>
                    <p>All Rights Reserved</p>
                    <span className="hidden sm:inline">|</span>
                    <p>Privacy Policy</p>
                </div>

            </div>
        </footer>
    );
}